export const headers = {
    'Content-Type': 'application/json'
};
